<script>
import Component from '~/sites/shop/pages/branch/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/pobocky',
      de: '/niederlassungen',
      en: '/branches',
      sk: '/pobocky',
    },
  },
}
</script>
